/**
 * @desc 导入研发物品
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(body: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/product/sku/importAddResearchItem`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
